<template>
  <div>
    <button class="button is-link" @click="imprimir">Imprimir</button>
    <br /><br />
    <y-printcomercialfactura
      v-if="
        data.comprobante &&
        data.comprobante.esfactura &&
        data.comprobante.estructura === 'comercial'
      "
      id="printable"
      :data="data"
      :total="total"
      :registros="registros"
      :iva="iva"
      :cliente="cliente"
      :subtotal="subtotal"
      :vencimiento="vencimiento"
      :cufe="cufe"
    ></y-printcomercialfactura>
    <y-printfrapvta
      v-if="
        registros.length > 0 &&
        data.comprobante &&
        data.comprobante.estructura === 'factura'
      "
      id="printable"
      :dataprint="dataprint"
      :cufe="cufe"
    ></y-printfrapvta>
  </div>
</template>

<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
import yPrintfrapvta from "@/components/prints/Frapvtaelectronica.vue";
import functions from "@/helpers/functions";
import yPrintcomercialfactura from "@/components/prints/Printcomercialfacturaelectronica.vue";
function getSum1(t, k, v, arr) {
  t.subtotal = t.subtotal + functions.dosDecimales(k.valor);
  t.iva = t.iva + functions.dosDecimales((k.valor * k.datosFactura.impuesto) / 100);
  t.total =
    t.total+
    k.valor +
    functions.dosDecimales((k.valor * k.datosFactura.impuesto) / 100);
  return t;
}
function getSum(t, k, v) {
  let debito = 0;
  let credito = 0;
  if (parseInt(k.tipo) === 1) {
    debito = k.valor;
    credito = 0;
  } else {
    debito = 0;
    credito = k.valor;
  }
  t.debito = parseInt(t.debito) + parseInt(debito);
  t.credito = parseInt(t.credito) + parseInt(credito);
  return t;
}
function sumarDias(fecha, dias) {
  fecha.setDate(fecha.getDate() + dias);
  return fecha;
}

export default {
  data() {
    return {
      cufe: "",
      idfra: "",
      data: {
        comprobante: null,
        mes: null,
        documento: null,
      },
      registros: [],
      total: { valor: 0 },
      vencimiento: null,
      iva: 0,
      subtotal: 0,
      cliente: { nombre: "" },
      dataprint: {
        totales: {
          subtotal: 0,
          iva: 0,
          total: 0,
        },
        empresa: {
          nit: "",
          nombrec: "",
          nombre: "",
          ciudad: "",
          direccion: "",
          telefono: "",
        },
        vencimiento: "2020-07-30T05:00:00.000Z",
        incluircambio: false,
        comprobante: {
          t1: "",
          t2: "",
          titulo: "",
          nombre: "",
          prefijo: "",
          caracteres: "",
          factura: {
            resolucion: "",
            piefactura: "",
            negrita: "",
            mensajefinal: "",
          },
        },
        contrapartidas: [
          {
            nombrepers: "",
          },
        ],
        contrapartida: {
          valor: 0,
          idcuenta: {
            nombre: "",
          },
        },
        registros: [
          {
            documento: 0,
            cantidad: 0,
            descuento: 0,
            vlrUnitario: 0,
            valor: 0,
            fecha: "2020-07-30T05:00:00.000Z",
            producto: {
              codigo: "",
              descripcion: "",
            },
            datosFactura: {
              texto: "",
              impuesto: 0,
              cambio: 0,
            },
            idnit: {
              nombre: "",
              codigo: "",
              direccion: "",
              ciudad: "",
              telefono: "",
              correo: "",
              fecha: "2020-07-30T05:00:00.000Z",
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapState(["isOculto", "empresa"]),
  },
  methods: {
    imprimir() {
      const _this = this;
      // functions.imprimir(this.data.comprobante.nombre,this.data.documento,this.data.mes.codigo);
      // this.$print("printable", {
      //   name: `${this.cufe}`,
      // });
      if (this.isOculto) {
        this.$store.commit("ocultarSide");
        setTimeout(() => {
          window.print();
          _this.$store.commit("ocultarSide");
        }, 200);
      } else {
        window.print();
      }
    },
    async traeRegistros(_this, documentoId, doc, periodo) {
      let result;
      try {
        result = await apiServices.get(
          `/mdocumento/${documentoId}/${doc}/${periodo}`
        );
        if (_this.data.comprobante.estructura === "contable") {
          _this.registros = result.data.map((e) => e);
          _this.total = result.data.reduce(getSum, {
            debito: 0,
            credito: 0,
          });
        } else if (_this.data.comprobante.estructura === "factura") {
          this.dataprint.empresa = this.empresa;
          this.dataprint.comprobante = this.data.comprobante;
          _this.registros = result.data;
          this.dataprint.registros = [];
          this.dataprint.contrapartida = {};
          this.dataprint.contrapartidas = [];
          if (
            this.usermongo &&
            this.usermongo.data.companys[this.empresa._id].preferences
              .incluircambio
          ) {
            this.dataprint.incluircambio = this.usermongo.data.companys[
              this.empresa._id
            ].preferences.incluircambio;
          }
          result.data.forEach(function (k, v) {
            if (k.idcuenta.ingreso) {
              _this.dataprint.registros.push(k);
            } else {
              if (_this.data.comprobante.cuenta === k.idcuenta._id) {
                _this.dataprint.contrapartida = k;
              } else {
                if (_this.data.comprobante.factura.contrapartidas) {
                  _this.data.comprobante.factura.contrapartidas.forEach(
                    function (k2, v2) {
                      if (k2._id === k.idcuenta._id) {
                        k.nombrepers = k2.nombre;
                        _this.dataprint.contrapartidas.push(k);
                      }
                    }
                  );
                }
              }
            }
          });

          _this.dataprint.totales = _this.dataprint.registros.reduce(getSum1, {
            subtotal: 0,
            iva: 0,
            total: 0,
          });
          var d = new Date(_this.dataprint.registros[0].fecha);
          var d1 = parseInt(_this.dataprint.registros[0].datosFactura.fpago);
          _this.dataprint.vencimiento = sumarDias(d, d1);
        } else if (_this.data.comprobante.estructura === "inventario") {
          _this.registros = [];
          result.data.forEach(function (key) {
            _this.registros.push(key);
          });
          _this.registros = functions.order(_this.registros, "orden");
        } else {
          _this.registros = [];
          result.data.forEach(function (key) {
            if (_this.data.comprobante.cuenta === key.idcuenta._id) {
              _this.total = key;
            } else {
              _this.registros.push(key);
            }
          });
          _this.registros = functions.order(_this.registros, "orden");
          if (_this.data.comprobante.esfactura) {
            const d = new Date(_this.total.fecha);
            const d1 = parseInt(_this.data.comprobante.vencimiento);
            _this.vencimiento = sumarDias(d, d1);
            let registros = _this.registros;
            _this.registros = [];
            _this.iva = 0;
            _this.subtotal = 0;
            for (var i = 0; i < result.data.length; i++) {
              if (result.data[i].idcuenta.tercero === true) {
                _this.cliente = result.data[i].idnit;
                if (result.data[i].idnit.ciudad) {
                  let largo = result.data[i].idnit.ciudad.length;
                  _this.cliente.ciudad = result.data[i].idnit.ciudad.substr(
                    9,
                    largo - 9
                  );
                } else {
                  _this.cliente.ciudad = false;
                }
                break;
              }
            }
            let iva = [];
            registros.forEach(function (key, val) {
              if (key.idcuenta.codigo.substr(0, 2) === "24") {
                iva.push(key);
              } else {
                _this.registros.push(key);
              }
            });
            if (iva.length > 0) {
              iva.forEach(function (key) {
                if (_this.total.tipo === key.tipo) {
                  _this.iva = _this.iva - key.valor;
                } else {
                  _this.iva = _this.iva + key.valor;
                }
              });
            }
            _this.registros.forEach(function (key) {
              if (_this.total.tipo === key.tipo) {
                _this.subtotal = _this.subtotal - key.valor;
              } else {
                _this.subtotal = _this.subtotal + key.valor;
              }
            });
          }
        }
      } catch (err) {
        console.log("ocurrio un problema cargando los documentos", err);
      }
    },
    transformperiodo(year, month) {
      let returned = month.toString();
      if (returned.length === 1) {
        returned = `0${returned}`;
      }
      returned = `${year}${returned}`;
      return returned;
    },
    async searchrep() {
      try {
        const result = await apiServices.get(
          `/searchrep/${this.$route.params.id}`
        );
        if (result.data) {
          if (result.data.cufe) {
            this.cufe = result.data.cufe;
          } else if (result.data.response.cufe) {
            this.cufe = result.data.response.cufe;
          } else {
            this.cufe = result.data.response.data.uuid;
          }
          let periodo = this.transformperiodo(
            result.data.year,
            result.data.mes
          );
          this.data.comprobante = result.data.comprobanteid;
          this.data.mes = result.data.mes;
          this.data.documento = result.data.documento;
          this.traeRegistros(
            this,
            result.data.comprobanteid._id,
            result.data.documento,
            periodo
          );
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.idfra = this.$route.params.id;
    this.searchrep();
  },
  components: {
    yPrintcomercialfactura,
    yPrintfrapvta,
  },
};
</script>

<style lang='scss'>
@media print {
  .button.is-link {
    display: none;
  }
  #printable {
    margin-top: -80px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/reports/fraelectronica/Repgrafica.vue